(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const submitSearch = (container) => {
      const input = container.querySelector('[data-facets-search-input]');
      const query = input?.value.trim();
      if (!query) return;
      const context = container.closest('.shopify-section')?.querySelector('[data-st-filter-context]') || document.querySelector('[data-st-filter-context]');
      const searchUrl = context?.dataset.searchUrl || `${window.Shopify?.routes?.root || '/'}search`;
      const params = new URLSearchParams({ type: 'product', q: query });
      window.location.href = `${searchUrl}?${params.toString()}`;
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-facets-search-submit]');
      const container = button?.closest('[data-facets-collection-search]');
      if (container) { event.preventDefault(); submitSearch(container); }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.matches('[data-facets-search-input]')) return;
      const container = event.target.closest('[data-facets-collection-search]');
      if (container) { event.preventDefault(); submitSearch(container); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
